import { render } from "./hotelReservations.vue?vue&type=template&id=b2978d00"
import script from "./hotelReservations.vue?vue&type=script&lang=js"
export * from "./hotelReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__